module.exports = {
  findPwd: {
    find: 'Reset your password',
    userName: 'Phone number or email address',
    error_userName_1: 'Please input phone number or email address',
    error_userName_2: 'User not existed',
    get_code: 'Send code',
    get_code_tip: 'Click to send verification code',
    get_code_tip_re: 's resend',
    code: 'Code',
    error_code_1: 'Please input verification code',
    error_code_2: '5 verification codes have been sent. Reach quantity limit of today.',
    error_code_3: 'Incorrect verification code',
    next: 'Continue',
    input_password: 'Password',
    repeat_new_password: 'Confirm password',
    new_password_error: 'Passwords do not match.',
    submit_new_password: 'Change password',
    success_relogin: 'New password set successfully.',
    button_relogin: 'Log in again'
  },
  register: {
    register: 'Join CZUR',
    phone_register: 'Register with phone number',
    email_register: 'Register with e-mail address',
    phone: 'Please input mobile phone number',
    error_phone: 'Invalid phone number',
    already_bound: 'User name exists',
    not_support: 'Channel does not support',
    code: 'Verification code',
    code_error: 'Wrong verification code',
    get_code: 'Send code',
    get_code_tip_re: 's resend',
    error_code_1: 'Verification code fields can\'t be blank',
    error_code_2: '5 verification codes have been sent. Reach quantity limit of today.',
    error_code_3: 'Incorrect verification code',
    error_code_4: 'Verification code sent. Valid for 10 mins. Do not send again within 10 mins.',
    error_code_5: 'Please do not request verification code in such a short period.',
    password_set: '8-20 digits and letters combination',
    password_error_1: 'Password fields can\'t be blank',
    protocol_a: 'I have read and accepted ',
    protocol_b: 'User terms',
    submit: 'Create an account',
    login_now: 'Log in here',
    success: 'Your account is now activated! Please log in and enjoy!',
    login_re: 'Return to log in page',
    email: 'Please input email address',
    email_error: 'Email format is incorrect',
    email_already_bound: 'This e-mail address has been registered.',
    accout_safe_tips: 'Please bind your phone number to this account for protection purpose.',
    password_repeat: 'Repeat 6~20 digit password',
    bind: 'Bind',
    password: 'Set password'
  },
  success: {
    activation: 'E-mail has been sent.',
    activation_email: 'The confirmation email has been sent to your mailbox ',
    click_email: ', click the confirmation link in the email to finish registration.',
    active_email: 'How to proceed if do not receive confirmation e-mail or the link in the e-mail is expired? ',
    email_help1: '● Check if the e-mail is in the junkbox or spam.',
    email_help2: '● Resend confirmation e-mail ',
    activation_success: 'Your CZUR account is now activated! Please log in to use CZUR cloud.',
    jumping_now: 'Go to log in page',
    activation_failed: 'The link is expired.',
    valueText: 'Click to resend',
    jumpingText: 'Jumping（',
    get_code_tip_re: 's resend',
    code_error1: 'You can request verification code for 5 times per day max..',
    code_error2: 'Failed to send'
  },
  index: {
    loginText: 'Log in',
    userName: 'Phone number or email address',
    password: 'Password',
    forgetPwd: 'Forgot password',
    register: 'Create an account',
    userTip: 'Please input mobile phone number or e-mail address',
    pwdTip: 'Please input password',
    loginFail: 'Wrong user name or password',
    errorFormat: 'Incorrect format',
    inactive: 'Please activate the account through the link in the e-mail you received.',
    resend: 'Click to resend',
    success: 'Sent',
    info: 'Account Center'
  },
  basic: {
  	editText: 'Edit',
  	updateText: 'Update',
  	logoutText: 'Log out',
  	czurId: 'CZUR ID',
  	emailBind: 'Bind with my e-mail',
  	phone: 'Phone number for account protection',
  	password: 'Password',
  	passwordSet: '(Set)',
  	bindText: 'Bind',
    unbindText: '(not bind yet)',
  	navText: 'Personal Center',
  	emailAddress: 'Email address',
  	emailEmpty: 'Please input the email address',
  	emailInvalid: 'Invalid email address',
  	emailBinds: 'This e-mail address has been binded to another account.',
  	codeEmpty: 'Please enter verification code',
  	codeError: 'Incorrect verification code',
  	fiveTimes: 'Max. 5 verification codes can be sent to the same e-mail address each day.',
  	hasSent: 'Verification code sent. The code is valid for 10 mins.',
  	highFrequency: 'Please do not request verification code in such a short period.',
  	emailCode: 'E-mail address verification code',
  	emailSend: 'Send code',
  	Submit: 'Submit',
  	sendAgain: 's resend',
  	validateEmail: 'Verify e-mail address',
  	emailSent: 'A verification code has been sent to the e-mail address.',
  	nextStep: 'Next',
  	successText: 'Successfully modified',
  	finishText: 'Done',
  	updatePwd: 'Change Password',
  	oldPwd: 'Current password',
  	newPwd: 'New password',
  	confirmPwd: 'Confirm new password',
  	oldPwdInput: 'Please enter the current password',
  	newPwdInput: 'Please enter the new password',
  	notSame: 'The new password can\'t be the same as the original password',
  	confirmPwdInput: 'Please enter the new password again.',
  	notSameWith: 'The passwords entered are not consistent.',
  	oldPwdInvalidate: 'The original password is invalid',
  	notExist: 'User does not exist',
  	fiveTime: 'Max. 5 verification codes can be sent to the same phone number each day.',
  	validatePhone: 'Verify phone number',
  	phoneSent: 'A SMS verification code has been sent to the phone number.',
  	phoneCode: 'SMS verification code',
  	phoneInput: 'Please input mobile phone number',
    error_phone: 'Invalid phone number',
    already_bound: 'User name exists',
    bindPhone: 'Bind phone',
    phoneNum: 'Phone number',
    uploadImg: 'Upload image',
    supportText: 'Only supports JPG, png, max. size 200KB',
    confirm: 'Confirm',
    cancel: 'Cancel',
    nicknameLong: 'Enter nickname. Max. 14 characters.',
    closeAcount: 'Close the account',
    nicknameEmpty: 'Nickname required.',
    nicknameEmoji: 'Avoid special characters or emojis.',
    area: 'Area',
    closeHint: 'Warm Reminder',
    closeText: 'CZUR Cloud account is the main account for CZUR APP, StarryMeeting, CZUR Scanner. By closing CZUR Cloud account, all of the accounts for the mentioned apps will be closed as well. Pleaes check again before you decide to proceed.',
    closeWarning: 'All data under this user will be cleared and cannot be restored if this account is closed. Please check again before you decide to proceed.',
    close: 'Close',
    code: 'Verification code',
    slelctCountry: 'Select country/area',
    lowPw: 'Your password is too simple. Please change a more complex combination.',
    logout: 'Log out'
  },
  titleText: {
    account_center: 'Personal Center',
    privacy: 'Privacy Policy - CZUR',
    create_account: 'Create Account - CZUR',
    terms_service: 'Terms of Service - CZUR',
    find_pwd: 'Find Passowrd - CZUR',
    active: 'Activate Account - CZUR',
    account_CZUR: 'Account Center - CZUR'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js